// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .pi {
  font-size: 10px;
  padding: 0 10px;
}
:host ::ng-deep .pi:focus {
  outline: none;
}
:host .breadcrumb {
  margin: 0;
  background-color: #f7f7f8;
  text-align: left;
  font-size: 12px;
  font-family: "GothamNarrowBook", "Helvetica Neue", Helvetica, Arial, sans-serif;
  letter-spacing: 0;
  text-transform: lowercase;
}
:host .breadcrumb label {
  color: #0066b2;
  cursor: pointer;
}
:host .breadcrumb label.last {
  color: #8c8f93;
  cursor: default;
}
:host .breadcrumb label:focus {
  outline: none;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
